import ImagesSlider from 'assets/core/js/module/images-slider'

export default {
  init: function () {
    document.querySelectorAll<HTMLElement>('.product__images .slider').forEach(function (el) {
      ImagesSlider(el, {
        pagination: {
          el: '.slider-pagination',
          type: 'custom',
          renderCustom: function (current: number, total: number) {
            return `${current}/${el.hasAttribute('data-total-images') ? (el.getAttribute('data-total-images') as string) : total}`
          },
        },
        spaceBetween: 10,
      })
    })
  },
}
